import React, { useMemo, useState } from 'react';

function DayPicker({ active : activProp, day, error = false, formatDate, setDate }) {
  const [active, setActive] = useState(activProp);
  const [invalid, setInvalid] = useState(error ? day : undefined);
  const formatted = useMemo(() => formatDate(new Date(day)), [formatDate, day]);

  if (!active) {
    return <button
      className={`inline minimal date${invalid ? ' error' : '' }`}
      onClick={() => setActive(true)}>
        {invalid || formatted}
      </button>
  }

  return (
      <input
        type="date"
        className={`inline minimal${invalid ? ' error' : '' }`}
        defaultValue={day}
        onChange={(event) => {
          if (invalid) {
            const { value } = event.target;
            const d = new Date(value);
            if (!isNaN(d)) {
              // This is a proper date string
              setInvalid(undefined);
              setDate(value);
            }
          }
        }}
        onBlur={(event) => {
          const { value } = event.target;
          if (value !== day) {
            const d = new Date(value);
            if (isNaN(d)) {
              // This is not a proper date string
              setInvalid(value);
            }
            setDate(value);
          }
          setActive(false);          
        }}
      />
  );
}

export default DayPicker;
